import React from 'react';
import { IconCalendarEvent, IconClockHour3 } from '@tabler/icons-react';
import { Input } from '../Input';
import { Select } from '../Select';
import { MSK_OFFSET, RU_TIMEZONES, buildTripTime, parseTripTime, toLocalDisplay, toMskDisplay } from '../../lib/tripTime';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

// Дата+время рейса «как в билете» + часовой пояс, рядом пересчёт по МСК.
const DateTimeTzInput = React.forwardRef<HTMLInputElement, Props>(({ value, onChange, onBlur }, ref) => {
  const parts = parseTripTime(value);
  const wall = parts?.wall ?? '';
  const offset = parts?.offset ?? MSK_OFFSET;
  const local = toLocalDisplay(value);
  const msk = toMskDisplay(value);

  const emit = (nextWall: string, nextOffset: string) => onChange(buildTripTime(nextWall, nextOffset));

  return (
    <div className="dtz">
      <Input
        ref={ref}
        type="datetime-local"
        className="inf-input"
        controlClassName="control-with-icon"
        icon={<IconCalendarEvent size={16} stroke={1.9} />}
        value={wall}
        onChange={e => emit(e.target.value, offset)}
        onBlur={onBlur}
      />
      <Select
        options={RU_TIMEZONES}
        value={offset}
        onChange={val => emit(wall, val)}
        placeholder="Часовой пояс"
      />
      {local && (
        <div className="dtz-times">
          <div className="dtz-msk">
            <IconClockHour3 size={13} stroke={1.9} />
            <span>Местное: {local}</span>
          </div>
          <div className="dtz-msk">
            <IconClockHour3 size={13} stroke={1.9} />
            <span>По Москве: {msk}</span>
          </div>
        </div>
      )}
    </div>
  );
});

DateTimeTzInput.displayName = 'DateTimeTzInput';

export { DateTimeTzInput };
